import SickLessons from './SickLessons';

export default SickLessons;
